import React from "react";
import {
  Card,
  PhotoRow,
  Photo,
  PhotoPlaceholder,
  Info,
  Name,
  Role,
  Subtitle,
  HighlightsList,
  HighlightItem,
  Bio
} from "./styled.components";

export interface TeamMemberCardProps {
  name: string;
  role: string;
  roleColor: string;
  subtitle: string;
  bio: string;
  photo?: string;
  highlights?: string[];
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({
  name,
  role,
  roleColor,
  subtitle,
  bio,
  photo,
  highlights
}) => (
  <Card>
    <PhotoRow>
      {photo ? <Photo src={photo} alt={name} /> : <PhotoPlaceholder />}
      <Info>
        <Name>{name}</Name>
        <Role $color={roleColor}>{role}</Role>
        <Subtitle>{subtitle}</Subtitle>
      </Info>
    </PhotoRow>
    {highlights && highlights.length > 0 && (
      <HighlightsList>
        {highlights.map((h, i) => (
          <HighlightItem key={i} $color={roleColor}>
            {h}
          </HighlightItem>
        ))}
      </HighlightsList>
    )}
    <Bio>{bio}</Bio>
  </Card>
);

export default TeamMemberCard;
